import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const reproductiveEventHistory: ImportTypeConfig = {
  type: 'reproductive-event-history',
}
